import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { PublishersQuery, PublishersQueryVariables } from './__generated__/PublishersQuery';

export const PUBLISHERS_QUERY = gql`
  query PublishersQuery(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $search: String
    $csmSearch: [String!]
  ) {
    publishers(first: $first, last: $last, before: $before, after: $after, search: $search, csmSearch: $csmSearch) {
      edges {
        node {
          id
          name
          active
          createdAt
          postMaloneAccount {
            externalAccountId
            name
          }
          accountManager {
            id
            email
          }
          temporaryAccountManager {
            id
            email
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        startCursor
      }
      totalCount
    }
  }
`;

export const usePublishersLazyQuery = () => {
  return useLazyQuery<PublishersQuery, PublishersQueryVariables>(PUBLISHERS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
